import Vue from 'vue';

export function httpCloudLists(data) {
  return  Vue.$axios({
    url: '/api/wallet/cloud/lists',
    method: 'post',
    data
  })
}
export function httpCloudCoins(data) {
  return  Vue.$axios({
    url: '/api/wallet/cloud/coins',
    method: 'post',
    data
  })
}
export function httpCloudAdd(data) {
  return  Vue.$axios({
    url: '/api/wallet/cloud/add',
    method: 'post',
    data
  })
}
export function httpCloudDelete(data) {
  return  Vue.$axios({
    url: '/api/wallet/cloud/delete',
    method: 'post',
    data
  })
}
export function httpCloudSearch(data) {
  return  Vue.$axios({
    url: '/api/wallet/cloud/search',
    method: 'post',
    data
  })
}
export function httpTransactions(data) {
  return  Vue.$axios({
    url: '/api/wallet/account/transactions',
    method: 'post',
    data
  })
}
export function httpAddress(data) {
  return  Vue.$axios({
    url: '/api/wallet/account/address',
    method: 'post',
    data
  })
}
export function httpNoticeLists(data) {
  return  Vue.$axios({
    url: '/api/home/notice/lists',
    method: 'post',
    data
  })
}
export function httpNoticeAddlike(data) {
  return  Vue.$axios({
    url: '/api/home/notice/doLike',
    method: 'post',
    data
  })
}
export function httpNoticeSublike(data) {
  return  Vue.$axios({
    url: '/api/home/notice/cancelLike',
    method: 'post',
    data
  })
}
export function httpNoticeAddcai(data) {
  return  Vue.$axios({
    url: '/api/home/notice/doCai',
    method: 'post',
    data
  })
}
export function httpNoticeSubcai(data) {
  return  Vue.$axios({
    url: '/api/home/notice/cancelCai',
    method: 'post',
    data
  })
}
export function httpAddressBookLists(data) {
  return  Vue.$axios({
    url: '/api/user/address_book/lists',
    method: 'post',
    data
  })
}
export function httpDelAddress(data) {
  return  Vue.$axios({
    url: '/api/user/address_book/delAddress',
    method: 'post',
    data
  })
}
export function httpAddAddress(data) {
  return  Vue.$axios({
    url: '/api/user/address_book/addAddress',
    method: 'post',
    data
  })
}
export function httpAccountTransfer(data) {
  return  Vue.$axios({
    url: '/api/wallet/account/transfer',
    method: 'post',
    data
  })
}
export function httpAccountTransferlocked(data) {
  return  Vue.$axios({
    url: '/api/wallet/account/transferlocked',
    method: 'post',
    data
  })
}
export function httpFromCoins(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/fromCoins',
    method: 'post',
    data
  })
}
export function httpToCoins(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/toCoins',
    method: 'post',
    data
  })
}
export function httpExchangeCheck(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/check',
    method: 'post',
    data
  })
}
export function httpExchangeCheckDiscount(data) {
    return  Vue.$axios({
      url: '/api/wallet/exchange/checkDiscount',
      method: 'post',
      data
    })
  }

export function httpRedEnvelopeInit(data) {
  return  Vue.$axios({
    url: '/api/wallet/red_envelope/init',
    method: 'post',
    data
  })
}
export function httpRedEnvelopeCoins(data) {
  return  Vue.$axios({
    url: '/api/wallet/red_envelope/coins',
    method: 'post',
    data
  })
}
export function httpRedEnvelopeMake(data) {
  return  Vue.$axios({
    url: '/api/wallet/red_envelope/make',
    method: 'post',
    data
  })
}
export function httpRedEnvelopeRecords(data) {
  return  Vue.$axios({
    url: '/api/wallet/red_envelope/records',
    method: 'post',
    data
  })
}
export function httpRedEnvelopeInfo(data) {
  return  Vue.$axios({
    url: '/api/wallet/red_envelope/info',
    method: 'post',
    data
  })
}
export function httpHDcoins(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd/coins',
    method: 'post',
    data
  })
}
export function httpHDadd(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd/add',
    method: 'post',
    data
  })
}
export function httpHDdelete(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd/delete',
    method: 'post',
    data
  })
}
export function httpHDsearch(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd/search',
    method: 'post',
    data
  })
}
export function httpAccountInfo(data) {
  return  Vue.$axios({
    url: '/api/wallet/account/info',
    method: 'post',
    data
  })
}
export function httpAccountTransactions(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_account/transactions',
    method: 'post',
    data
  })
}
export function httpAccountHDInfo(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_account/info',
    method: 'post',
    data
  })
}
export function httpAccountHDAddress(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_account/address',
    method: 'post',
    data
  })
}
export function httpExchangeOrder(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/order',
    method: 'post',
    data
  })
}
export function httpExchangeOrderDiscount(data) {
    return  Vue.$axios({
      url: '/api/wallet/exchange/orderDiscount',
      method: 'post',
      data
    })
  }

export function httpExchangePay(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/pay',
    method: 'post',
    data
  })
}
export function httpPrepare(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_transaction/prepare',
    method: 'post',
    data
  })
}
export function httpHdTransactionSend(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_transaction/send',
    method: 'post',
    data
  })
}

export function httpHdTransactionSend2(data) {
  return  Vue.$axios({
    url: '/api/wallet/hd_transaction/send2',
    method: 'post',
    data
  })
}

export function httpShopList(data) {
  return  Vue.$axios({
    url: '/api/wallet/shop/list',
    method: 'post',
    data
  })
}
export function httpShopInfo(data) {
  return  Vue.$axios({
    url: '/api/wallet/shop/info',
    method: 'post',
    data
  })
}
export function httpShopExchange(data) {
  return  Vue.$axios({
    url: '/api/wallet/shop/exchange',
    method: 'post',
    data
  })
}
export function httpTaskList(data) {
  return  Vue.$axios({
    url: '/api/wallet/task/list',
    method: 'post',
    data
  })
}
export function httpFinishTask(data) {
  return  Vue.$axios({
    url: '/api/wallet/task/finish',
    method: 'post',
    data
  })
}
export function httpScoreInfo(data) {
  return  Vue.$axios({
    url: '/api/wallet/score/info',
    method: 'post',
    data
  })
}
export function httpInvitationInfo(data) {
  return  Vue.$axios({
    url: '/api/user/invitation/info',
    method: 'post',
    data
  })
}
export function httpInvitationRegList(data) {
  return  Vue.$axios({
    url: '/api/user/invitation/getList',
    method: 'post',
    data
  })
}
export function httpTaskorder(data) {
  return  Vue.$axios({
    url: '/api/wallet/task/log',
    method: 'post',
    data
  })
}
export function httpShoporder(data) {
  return  Vue.$axios({
    url: '/api/wallet/shop/log',
    method: 'post',
    data
  })
}
export function httpMyccorder(data) {
  return  Vue.$axios({
    url: '/api/wallet/score/log',
    method: 'post',
    data
  })
}
export function httpDepositUserList(data) {
  return  Vue.$axios({
    url: '/api/user/invitation/getDepositUserList',
    method: 'post',
    data
  })
}

export function httpPackageOrder(data) {
  return  Vue.$axios({
    url: '/api/wallet/package/order',
    method: 'post',
    data
  })
}

export function mmtOrder(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/mmtorder',
    method: 'post',
    data
  })
}

export function getMmtOrder(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/getmmtorderdetail',
    method: 'post',
    data
  })
}

export function postMmtPrize(data) {
  return  Vue.$axios({
    url: '/api/wallet/exchange/postmmtprize',
    method: 'post',
    data
  })
}
